import type { IconSvgObject } from './types';

const MapsEditingIcon: IconSvgObject = [
  ["path", { d: "M10.5 19L8 18L3.31623 19.5613C2.6687 19.7771 2 19.2951 2 18.6126V6.61803C2 6.23926 2.214 5.893 2.55279 5.72361L7.58517 3.20742C7.84826 3.07587 8.15593 3.06683 8.4263 3.1827L15 6H21C21.5523 6 22 6.44772 22 7V11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 3L8 18", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M15 6V12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M14 18.5V21H16.5L22 15.5L19.5 13L14 18.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default MapsEditingIcon;
